import { render } from "./edit-goods-list.vue?vue&type=template&id=1c676833&scoped=true&ts=true"
import script from "./edit-goods-list.vue?vue&type=script&lang=ts"
export * from "./edit-goods-list.vue?vue&type=script&lang=ts"

import "./edit-goods-list.vue?vue&type=style&index=0&id=1c676833&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c676833"]])

export default __exports__